import React, { MouseEvent } from 'react';
import { Trans } from 'common/i18n';
import { useTranslation } from 'common/i18n/hooks';
import { react2panel } from 'common/util/react2panel';
type UpgradePlanProps = {
  onClickUpsell: (ev: MouseEvent) => void;
};
export function UpgradePlan(props: UpgradePlanProps) {
  const {
    t
  } = useTranslation();
  return <Trans i18nKey={"settings.org-settings.invite-users.upgrade-plan-link"} t={t} components={{
    ctaLink: <a id='#pricing-link' href={"/pricing"} onClick={props.onClickUpsell} />
  }} data-sentry-element="Trans" data-sentry-component="UpgradePlan" data-sentry-source-file="upgrade-plan.tsx" />;
}
export const UpgradePlanEl = react2panel("mp-invite-user-upgrade-plan", UpgradePlan);